import camelcaseKeys from "camelcase-keys";
import { current } from "immer";
import * as z from "zod";

import { Customer, CustomerSchema } from "../Customer/schema";
import { SessionActions } from "../Session/reducer";
import {
  BillSplit,
  BillSplitSchema,
  CustomerSession,
  CustomerSessionSchema,
  OrderItemClaim,
  OrderItemClaimSchema,
} from "./schema";

export const BillSplitActionsSchema = z.discriminatedUnion("action", [
  z.object({ action: z.literal("addCustomer"), payload: CustomerSchema }),
  z.object({
    action: z.literal("addCustomerSession"),
    payload: CustomerSessionSchema,
  }),
  z.object({
    action: z.literal("updateCustomerSession"),
    payload: CustomerSessionSchema,
  }),
  z.object({
    action: z.literal("addCustomerToSession"),
    payload: z.object({
      customer: CustomerSchema,
      customerSession: CustomerSessionSchema,
    }),
  }),
  z.object({ action: z.literal("removeCustomer"), payload: CustomerSchema }),
  z.object({ action: z.literal("updateCustomer"), payload: CustomerSchema }),
  z.object({
    action: z.literal("addOrderItemClaim"),
    payload: OrderItemClaimSchema,
  }),
  z.object({
    action: z.literal("removeOrderItemClaim"),
    payload: OrderItemClaimSchema,
  }),
  z.object({
    action: z.literal("initialize"),
    payload: BillSplitSchema,
  }),
]);

export const parseChannelData = (data: any): BillSplitActions => {
  console.log("parsedData", camelcaseKeys(data, { deep: true }));
  const parsed = BillSplitActionsSchema.parse(
    camelcaseKeys(data, { deep: true })
  );
  return parsed;
};
export type BillSplitActions = z.infer<typeof BillSplitActionsSchema>;
// type BillSplitActions =
//   | { action: "addCustomer"; payload: Customer }
//   | { action: "addCustomerSession"; payload: CustomerSession }
//   | {
//       action: "addCustomerToSession";
//       payload: { customer: Customer; customerSession: CustomerSession };
//     }
//   | { action: "removeCustomer"; payload: Customer }
//   | { action: "updateCustomer"; payload: Customer }
//   | { action: "addOrderItemClaim"; payload: OrderItemClaim }
//   | { action: "removeOrderItemClaim"; payload: OrderItemClaim };

const addCustomer = (session: BillSplit, customer: Customer): void => {
  if (session.customers.find((c) => c.uuid === customer.uuid)) {
    return;
  }
  session.customers.push(customer);
};

const updateCustomer = (session: BillSplit, customer: Customer): void => {
  session.customers = session.customers.map((c) =>
    c.uuid === customer.uuid ? customer : c
  );
};

const updateCustomerSession = (
  session: BillSplit,
  customerSession: CustomerSession
): void => {
  session.customerSessions = session.customerSessions.map((cs) =>
    cs.uuid === customerSession.uuid ? customerSession : cs
  );
};

// Moved to React Query
export const addCustomerSession = (
  session: BillSplit,
  customerSession: CustomerSession
): void => {
  if (session.customerSessions.find((cs) => cs.uuid === customerSession.uuid)) {
    return;
  }
  session.customerSessions.push(customerSession);
};

export const addOrderItemClaim = (
  session: BillSplit,
  orderItemClaim: OrderItemClaim
) => {
  session.orderItemClaims.push(orderItemClaim);
};

export const removeOrderItemClaim = (
  session: BillSplit,
  orderItemClaim: OrderItemClaim
) => {
  session.orderItemClaims = session.orderItemClaims.filter(
    (oic) => oic.uuid !== orderItemClaim.uuid
  );
};

export const BillSplitReducer = (
  billSplitSession: BillSplit,
  action: BillSplitActions
): void | BillSplit => {
  console.log("billSplitSession", {
    action,
    billSplitSession: billSplitSession && current(billSplitSession),
  });
  switch (action.action) {
    case "initialize":
      return action.payload;
    case "addCustomer":
      addCustomer(billSplitSession, action.payload);
      break;
    case "addCustomerSession":
      addCustomerSession(billSplitSession, action.payload);
      break;
    case "updateCustomerSession":
      updateCustomerSession(billSplitSession, action.payload);
      break;
    case "addCustomerToSession":
      addCustomer(billSplitSession, action.payload.customer);
      addCustomerSession(billSplitSession, action.payload.customerSession);
      break;
    case "removeCustomer":
      break;
    case "updateCustomer":
      updateCustomer(billSplitSession, action.payload);
      break;
    case "addOrderItemClaim":
      addOrderItemClaim(billSplitSession, action.payload);
      break;
    case "removeOrderItemClaim":
      removeOrderItemClaim(billSplitSession, action.payload);
      break;
    default:
      return billSplitSession;
  }
};
